import { render, staticRenderFns } from "./AddressesLimitManagement.vue?vue&type=template&id=34b2b5e9&scoped=true&"
import script from "./AddressesLimitManagement.vue?vue&type=script&lang=js&"
export * from "./AddressesLimitManagement.vue?vue&type=script&lang=js&"
import style0 from "./AddressesLimitManagement.vue?vue&type=style&index=0&id=34b2b5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2b5e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
